import { render, staticRenderFns } from "./TeamStewardForm.vue?vue&type=template&id=18be6b7a&scoped=true&"
import script from "./TeamStewardForm.vue?vue&type=script&lang=js&"
export * from "./TeamStewardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18be6b7a",
  null
  
)

export default component.exports